import { useState } from 'react';
import { Box, CssBaseline, ThemeProvider } from '@mui/material';
import { BrowserRouter, BrowserRouter as Router } from 'react-router-dom';
import { theme } from './styles/theme';
import { Sidebar } from './components/Sidebar/Sidebar';
import { Dashboard } from './components/Dashboard/Dashboard';
import { AppRouter } from './AppRouter';

const drawerWidth = 240;

export const App = () => {
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <ThemeProvider theme={theme}>
       <BrowserRouter>
         
          <AppRouter /> 
      </BrowserRouter>
      {/* <Router>
        <Box sx={{ display: 'flex' }}>
          <CssBaseline />
          <Sidebar mobileOpen={mobileOpen} handleDrawerToggle={handleDrawerToggle} drawerWidth={drawerWidth} />
          <Box 
            component="main" 
            sx={{ 
              flexGrow: 1, 
              p: 3,
              width: { sm: `calc(100% - ${drawerWidth}px)` },
              // ml: { sm: `${drawerWidth}px` }
            }}
          >
            <Dashboard />
          </Box>
        </Box>
      </Router> */}
    </ThemeProvider>
  );
};